/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowUpLeft = createReactComponent("outline", "arrow-up-left", "IconArrowUpLeft", [["path", { "d": "M7 7l10 10", "key": "svg-0" }], ["path", { "d": "M16 7l-9 0l0 9", "key": "svg-1" }]]);

export { IconArrowUpLeft as default };
//# sourceMappingURL=IconArrowUpLeft.mjs.map
